import SsgFallback from '@components/SsgFallback'
import getWebsiteIdFromDomain from '@data/queries/website/websiteIdFromDomain'
import getWebsiteInitialData from '@data/queries/website/websiteInitialData'
import getWebsiteMenuInformation from '@data/queries/website/websiteMenuInformation'
import {getProductIdFromOrderUrl} from '@helpers/middleware/sharedPages/product'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import getSsrComponentMapForOrderPage from '@helpers/ssr/getSsrComponentMapForOrderPage'
import useSharedPageRewriteHelper from '@hooks/useSharedPageRewriteHelper'
import Layout from '@page-components/Layout'
import NoWebsite from '@page-components/NoWebsite'
import Order from '@page-components/Order'
import {InferGetStaticPropsType} from 'next'

export default function OrderPage(props: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useSharedPageRewriteHelper('productId', getProductIdFromOrderUrl)

  if (router.isFallback) {
    return <SsgFallback />
  }

  if (!props.website) {
    return <NoWebsite />
  }

  return (
    <Layout initialData={props.initialData}>
      <Order
        page={props.page}
        componentIdToSsrProps={props.componentIdToSsrProps}
        website={props.website}
        design={props.design}
        productId={
          Array.isArray(router.query.productId) ? router.query.productId[0] : router.query.productId
        }
        // categories={props.categories}
      />
    </Layout>
  )
}

export const getStaticProps = async context => {
  const websiteId = await getWebsiteIdFromDomain(context.params.hostname)
  const initialData = await getWebsiteInitialData(websiteId)
  const {website, design} = await getWebsiteMenuInformation(websiteId)

  /**
   * Note: disabled preloading items for now as it slows down SSR for pages with a lot of products
   * In the future: We need to optimize and paginate items EVERYWHERE.
   * Left for reference in case we want to reenable in the future.
   */

  // const categories: getCategoriesAndProductsWeb_cached_categories = website
  //   ? isStore(website.businessType)
  //     ? await getCategoriesForCPGWebsite({websiteId, menuId: website.defaultMenuId})
  //     : await getCategoriesForWebsite({websiteId, menuId: website.defaultMenuId})
  //   : ({items: []} as getCategoriesAndProductsWeb_cached_categories)

  const {page, componentIdToSsrProps} = await getSsrComponentMapForOrderPage(
    initialData,
    websiteId,
    context
  )

  return {
    props: {
      ...(await websiteSSRTranslations(website)),
      initialData,
      websiteId,
      website,
      design,
      // categories,
      page,
      componentIdToSsrProps
    },
    revalidate: 60 * 60 * 24 // Revalidated on demand
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
